import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import immutableCreatorSelector from '../../../selectors/immutableCreatorSelector';

import RelationshipTypes from './RelationshipTypes';

import { RelationshipTypeActions } from '../../../actions/relationshipType';

import {
  relationshipTypesSelector,
  shouldLoadRelationshipTypesSelector,
  sortSelector,
} from '../../../reducers/relationshipTypes';
import {
  iconsSelector,
} from '../../../reducers/icons';
import {
  currentProjectIdSelector,
} from '../../../reducers/projects';
import '../../../styles/RelationshipTypeDefaultTab.css';

const RelationshipTypesContainerSelector = immutableCreatorSelector(
  [
    relationshipTypesSelector,
    iconsSelector,
    sortSelector,
    currentProjectIdSelector,
    shouldLoadRelationshipTypesSelector,
  ],
  (relationshipTypes, icons, sort, currentProjectId, shouldLoadRelationshipTypes) => {
    return {
      relationshipTypes,
      icons,
      sort,
      currentProjectId,
      shouldLoadRelationshipTypes,
    };
  }
);

@connect(RelationshipTypesContainerSelector)
export default
class RelationshipTypesContainer extends Component {
  static propTypes = {
    currentProjectId: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    relationshipTypes: PropTypes.instanceOf(Map),
    shouldLoadRelationshipTypes: PropTypes.bool,
  }

  componentWillMount() {
    const { currentProjectId, shouldLoadRelationshipTypes, dispatch } = this.props;

    if (shouldLoadRelationshipTypes) {
      dispatch(RelationshipTypeActions.getProjectRelationshipTypes(currentProjectId));
    }
  }

  render() {
    return <RelationshipTypes {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/views/ProjectSettings/RelationshipTypes/RelationshipTypesContainer.js